module.exports = __webpack_public_path__ + "static/assets/722d704a731aeef4e4db53650e59887c.svg";